<template>
  <div class="instructions">
    רישום מהיר ומאובטח באמצעות אתר דיסקונט:
  </div>
</template>

<script>
export default {
  name: 'DiscountApiInstructions',
};
</script>

<style lang="scss" scoped>
</style>
